import {
  DeveloperModeContext,
  type DeveloperModeContextValue,
} from '@mxa-argos/core/contexts/developer-mode.context';
import { useContext } from 'react';

export function useDeveloperMode(): DeveloperModeContextValue {
  return useContext(DeveloperModeContext);
}
